import {
  COMMAND_CENTRE_ASSIGN_JOB,
  COMMAND_CENTRE_ASSIGNABLE_JOBS,
  COMMAND_CENTRE_CAMERA_STREAM,
  COMMAND_CENTRE_CAMERAS,
  COMMAND_CENTRE_CONFIG,
  COMMAND_CENTRE_EVENTS,
  COMMAND_CENTRE_OPERATOR,
  COMMAND_CENTRE_OPERATORS,
  COMMAND_CENTRE_POSITIONS,
  COMMAND_CENTRE_SITES,
} from '@/api/Core/endpoints';
import {
  CommandCentreCamera,
  CommandCentreOperator,
  CommandCentreSite,
  LiveUpdateRow,
  CommandCentrePosition,
  OperatorProfile,
  AssignableJobsPage,
  AssignJobRequest,
  AssignJobResponse,
  AssignableJobsCreatedSort,
} from '@/types';
import { Core } from '../Core/Core';

export interface LiveUpdatesPageResponse {
  siteId: number;
  page: number;
  pageSize: number;
  totalCount: number;
  items: LiveUpdateRow[];
}

export interface CommandCentreConfig {
  offlineSeconds: number;
  linkHealthGoodSeconds: number;
  decayTickMs: number;
  awayTimeoutMinutes: number;
}

class CommandCentreApi extends Core {
  getConfig = () => this.get<CommandCentreConfig>(COMMAND_CENTRE_CONFIG());

  getSites = () => this.get<CommandCentreSite[]>(COMMAND_CENTRE_SITES());
  getPositions = (siteId: number) =>
    this.get<CommandCentrePosition[]>(COMMAND_CENTRE_POSITIONS(siteId));

  getOperators = (siteId: number) =>
    this.get<CommandCentreOperator[]>(COMMAND_CENTRE_OPERATORS(siteId));

  getEvents = (siteId: number, page = 1, pageSize = 20, types?: string[]) =>
    this.get<LiveUpdatesPageResponse>(COMMAND_CENTRE_EVENTS(siteId), {
      page,
      pageSize,
      ...(types?.length ? { types } : {}),
    });

  getCameras = (siteId: number) =>
    this.get<CommandCentreCamera[]>(COMMAND_CENTRE_CAMERAS(siteId));

  getCameraStream = (cameraId: number) =>
    this.get<{
      cameraId: number;
      name: string;
      streamUrl: string;
      isOnline: boolean;
    }>(COMMAND_CENTRE_CAMERA_STREAM(cameraId));

  getOperator = (userId: number, siteId?: number) =>
    this.get<OperatorProfile>(
      COMMAND_CENTRE_OPERATOR(userId),
      siteId ? { siteId } : undefined,
    );

  getAssignableJobs = (
    siteId: number,
    search = '',
    jobType?: string,
    createdSort: AssignableJobsCreatedSort = 'desc',
    page = 1,
    pageSize = 10,
  ) =>
    this.get<AssignableJobsPage>(COMMAND_CENTRE_ASSIGNABLE_JOBS(siteId), {
      search,
      jobType,
      createdSort,
      page,
      pageSize,
    });

  assignJob = ({ userId, jobId, siteId, expectedOwnerId }: AssignJobRequest) =>
    this.post<AssignJobResponse>(COMMAND_CENTRE_ASSIGN_JOB(userId), {
      job_id: jobId,
      site_id: siteId,
      expected_owner_id: expectedOwnerId,
    });
}

export const commandCentre = new CommandCentreApi();
